import { CountryItem } from './countryTypes'
import { filterAndSortFields } from './../identifyUtils.ts'
import {
  nationalId,
  email,
  username,
  password,
  phonenumber,
  firstName,
  lastName,
  address1,
  address2,
  zip,
  city } from './../identifyFields.ts'
import { frejaId, ftn, manual } from './../providers/index.ts'

export const finland: object = (fieldsToInclude, KYCFields): CountryItem => {
  // filter out based on the passed in fields and only returned the matching ones
  let fields = [
    email,
    phonenumber,
    firstName,
    lastName,
    address1,
    address2,
    zip,
    city
  ]
  const providers = [
    ftn,
    frejaId,
    manual
  ]

  const settings = {
    rememberDevice: true, // should it be an opt in or opt out
    storeData: true // should it be an opt in or opt out
  }

  if (fieldsToInclude) {
    // filter out based on the passed in fields and only returned the matching ones
    fields = filterAndSortFields(fields, fieldsToInclude)
  } else if (KYCFields) {
    fields = fields.filter(field => field.includeInKYC === undefined || field.includeInKYC === true) // Don't include fields we only use in the identity wizard
  }

  return {
    fields,
    providers,
    settings
  }
}
